import _ from 'lodash';
import {fetch} from 'shared/models/categoryGroup';

const init = {categories: []};
const CATEGORY_GROUP_UPDATE = 'CATEGORY_GROUP_UPDATE';
const CATEGORY_GROUP_LOADING = 'CATEGORY_GROUP_LOADING';

export default function(state = init, action = {}) {
  switch (action.type) {
    case CATEGORY_GROUP_UPDATE:
      return _.assign({}, state, action.result, { loading: false });
    case CATEGORY_GROUP_LOADING:
      return {...state, loading: true};
    default:
      return state;
  }
}

export function loadCategoryGroup(name = '') {
  return (dispatch, getState) => {
    name = name || getState().categoryGroup.name;
    dispatch({ type: CATEGORY_GROUP_LOADING });
    return fetch(name).then(result => {
      dispatch({type: CATEGORY_GROUP_UPDATE, result: result});
    })
  }
}



// WEBPACK FOOTER //
// ./shared/components/categoryGroup/actions.js